import React, {useEffect, useState} from 'react';

interface CaptchaProps {
    skip: boolean;
    setSkip: (skip: boolean) => any;
}

export function Captcha1(props: CaptchaProps) {

    const [selectedPiece, setSelectedPiece] = useState("");

    useEffect(() => {
        props.setSkip(selectedPiece == "");
    },[selectedPiece]);

    return(
        <div>
            <div className={"wrapper"}>
                <div className={(selectedPiece == "piece1" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece1"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece1" ? "" : "piece1")}}>
                    </div>
                </div>
                <div className={(selectedPiece == "piece2" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece2"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece2" ? "" : "piece2")}}>
                    </div>
                </div>
                <div className={(selectedPiece == "piece3" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece3"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece3" ? "" : "piece3")}}>
                    </div>
                </div>

            </div>

            <div className={"wrapper"}>
                <div className={(selectedPiece == "piece4" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece4"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece4" ? "" : "piece4")}}>
                    </div>
                </div>
                <div className={(selectedPiece == "piece5" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece5"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece5" ? "" : "piece5")}}>
                    </div>
                </div>
                <div className={(selectedPiece == "piece6" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece6"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece6" ? "" : "piece6")}}>
                    </div>
                </div>
            </div>

            <div className={"wrapper"}>
                <div className={(selectedPiece == "piece7" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece7"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece7" ? "" : "piece7")}}>
                    </div>
                </div>
                <div className={(selectedPiece == "piece8" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece8"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece8" ? "" : "piece8")}}>
                    </div>
                </div>
                <div className={(selectedPiece == "piece9" ? "selected" : "")}>
                    <label  className={"checkboxLabel"}></label>
                    <div className="puzzle piece9"
                         onClick={event => {
                             setSelectedPiece(selectedPiece == "piece9" ? "" : "piece9")}}>
                    </div>
                </div>
            </div>
        </div>
    )

}



//export default Captcha1;
